module.exports = "<i class=\"material-icons\" [ngStyle]=\"{ color: color }\">\n  {{ icon }}\n</i>\n"